import React, { useState, useEffect, useContext } from "react";
import "./Header.scss";
import {
  shareFacebook,
  shareWhatsapp,
  openNegishut,
  shareWhatsappArticle,
  shareFacebookArticle,
} from "../../Services/Sharing";
import { AppContext } from "../../stores/application.store";
import { mobile } from "../../Services/Agent";
import { Link, Redirect } from 'react-router-dom';
import { Environment } from "../../Services/Base";
import { useRef } from "react";


const Header = () => {
  let [open, setOpen] = useState(false);
  let [openShare, setOpenShare] = useState(false);
  let [pop, setPop] = useState(false);
  let goToHomeRef = useRef(null);

  // Application Store context
  let { scroll, setScroll } = useContext(AppContext)
  let { inArticle, toggleArticle, setInArticle } = useContext(AppContext)
  // let [isMobile , setIsMobile] = useState(mobile())

  let isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
  );

  let isQA = Boolean(
    window.location.href.match("source-qa") ||
    window.location.href.match("qa.")
  );

  // Custom hook that listen to the URL
  const useReactPath = () => {
    const [path, setPath] = useState(window.location.href);
    const listenToPopstate = () => {
      const winPath = window.location.href;
      setPath(winPath);
    };
    useEffect(() => {
      window.addEventListener("popstate", listenToPopstate);
      return () => {
        window.removeEventListener("popstate", listenToPopstate);
      };
    }, []);
    return path;
  };
  // Checks if in article algo
  const path = useReactPath();
  useEffect(() => {
    // console.log(/^[0-9]{7}$/.test(window.location.hash.split("/")[1]))
    setInArticle(/^[0-9]{7}$/.test(window.location.hash.split("/")[1]));
  }, [path]);


  useEffect(() => {
    let loaded = sessionStorage.getItem("hasLoaded");
    let time = loaded ? 0 : 5500;
    setTimeout(() => {
      setPop(true);
    }, time);
  }, []);

  useEffect(() => {
  }, [scroll])

  const scrollMachine = (name) => {
    if (inArticle) {
      document.querySelector(".back_home").click()
    }
    setOpen(!open);
    const see = document.querySelector("#video_section");
    const know = document.querySelector(".should_know");
    const buy = document.querySelector(".should_buy");
    const doSec = document.querySelector(".should_do");
    const settings = {
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    };
    switch (name) {
      case "see":
        setScroll(scroll => scroll = 1)
        // see.scrollIntoView(settings);
        break;
      case "know":
        setScroll(scroll => scroll = 2)
        // know.scrollIntoView(settings);
        break;
      case "buy":
        setScroll(scroll => scroll = 3)
        // buy.scrollIntoView(settings);
        break;
      case "do":
        setScroll(scroll => scroll = 4)
        // doSec.scrollIntoView(settings);
        break;
      default:
        return;
    }
  };

  const siteTravel = (where) => {
    switch (where) {
      case "up":
        if (scroll > 0) {
          setScroll(scroll => scroll - 1)
        }
        break;
      case "down":
        if (scroll < 4) {
          setScroll(scroll => scroll + 1)
        }
        break;
      default:
        return;
    }
  };

  // return(
  //   inArticle ? <h1>ARTICLE</h1> : <h4>not</h4>
  // )
  // useEffect(()=> {
  //   Environment
  // } ,[])

  function goHome(e) {
    //window.history.back()
    setScroll(scroll > 0 ? (e.target.className.indexOf("homepage") > -1 ? 0 : 2) : 0);
    toggleArticle()
  }

  function handleShare(name) {
    // console.log("name : ", name)
    if (name === "wa") {
      if (inArticle) {
        // console.log("in  shareWhatsappArticle(window.location.href)")
        shareWhatsappArticle(window.location.href)
      } else {
        shareWhatsapp()
      }
    } else {
      if (inArticle) {
        shareFacebookArticle(window.location.href)
      } else {
        shareFacebook()
      }
    }
  }

  function getHref() {
    if (isLocalhost) {
      return "/"
    }
    else if (isQA) {
      return "http://source-qa-a.ynet.co.il/short/content/2020/VReality/#/"
    } else {
      return "https://z.ynet.co.il/short/content/2020/VReality/#/"
    }
  }

  return (
    <header>
      <div className="nav-sec">
        <div className={`ham_wrapper ${inArticle && "article"}`}>
          <div className={`up arrow ${scroll === 0 && "in-active"}`} onClick={() => siteTravel("up")}>
            <i className="fas fa-arrow-up"></i>
          </div>
          <div
            className={`hamburger ${open && "x"}`}
            onClick={() => setOpen(!open)}
          ></div>
          <div className={`down arrow ${scroll === 4 && "in-active"}`} onClick={() => siteTravel("down")}>
            <i className="fas fa-arrow-down"></i>
          </div>
          {/* <a href={`${getHref()}`} className="back_home" onClick={() => goHome()}>
                <div className=""><i className="fas fa-arrow-right"></i></div>
                <div className="text">חזרה לכתבות</div> 
            </a> */}
          <Link to="/" ref={goToHomeRef} className="back_home" onClick={(e) => goHome(e)}>
            <div className=""><i className="fas fa-arrow-right"></i></div>
            <div className="text">חזרה לכתבות</div>
          </Link>
        </div>
        <a
          className="ynet"
          href="https://www.ynet.co.il/home/0,7340,L-8,00.html"
          target="_blank"
        ></a>
        <div onClick={() => {
          setScroll(0);
          if (inArticle) {
            goToHomeRef.current.classList.add("homepage")
            goToHomeRef.current.click();
          }
        }} className={`jelly_appear ${pop && "pop"}`}></div>
        <div className="sharer_wrapper">
          <div className="ngishut" onClick={openNegishut}></div>
          <div
            className={`share ${openShare && "active"}`}
            onClick={() => setOpenShare(!openShare)}
          ></div>
          <div
            className={`fb ${openShare && "active"}`}
            onClick={() => handleShare("")}
          ></div>
          <div
            className={`wa ${openShare && "active"}`}
            onClick={() => handleShare("wa")}
          ></div>
        </div>
      </div>
      <div className={`menu ${open && "active"}`}>
        <div className="whale"></div>
        <div
          className="menu_item_wrapper one"
          onClick={() => scrollMachine("see")}
        >
          <div className="suitcase"></div>
          <div className="menu_item_text">מה שכדאי לראות</div>
        </div>
        <div
          className="menu_item_wrapper two"
          onClick={() => scrollMachine("know")}
        >
          <div className="suitcase"></div>
          <div className="menu_item_text">מה שכדאי לדעת</div>
        </div>
        <div
          className="menu_item_wrapper one"
          onClick={() => scrollMachine("buy")}
        >
          <div className="suitcase"></div>
          <div className="menu_item_text"> מה שכדאי לקנות</div>
        </div>
        <div
          className="menu_item_wrapper two"
          onClick={() => scrollMachine("do")}
        >
          <div className="suitcase"></div>
          <div className="menu_item_text">מה שכדאי לעשות</div>
        </div>
        <div className="share_wrapper_mobile">
          <div
            className={`share ${openShare && "active"}`}
            onClick={() => setOpenShare(!openShare)}
          ></div>
          <div
            className={`fb ${openShare && "active"}`}
            onClick={() => handleShare("")}
          ></div>
          <div
            className={`wa ${openShare && "active"}`}
            onClick={() => handleShare("wa")}
          ></div>
        </div>
        <div className="ngishut_mobile" onClick={openNegishut}></div>
      </div>
    </header>
  );
};

export default Header;
